import React from "react";
import styles from "../Styles/MobileOnlyContent.module.scss";

export default class MobileOnlyContent extends React.Component {
  render() {
    return <div className={styles.mobileOnly}>{this.props.children}</div>;
  }
}
